import { dictConstants } from '../consts/dict.constants';

export function formatReqUserRole(role) {
    if (dictConstants.role[role]) return dictConstants.role[role];
    return 'Не выбрано...';
}
